import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'

import { ActionRowVariant } from './types'
import { hyperEVM } from '@/config/chain/constants'
import { getDisplayToken } from '@/domain/hooks/useDisplayToken'

export function getFormattedValue(value: NormalizedUnitNumber, token: Token, variant: ActionRowVariant): string {
  const formattedValue = token.format(value, { style: 'auto' })
  const includeAmount = variant === 'extended'
  const displaySymbol = getDisplayToken(hyperEVM.id, token).symbol
  if (includeAmount) {
    return `${formattedValue} ${displaySymbol}`
  }
  return displaySymbol
}
